import { render, staticRenderFns } from "./TokensApp.html?vue&type=template&id=bfa0ccf2&scoped=true&"
import script from "./TokensApp.js?vue&type=script&lang=js&"
export * from "./TokensApp.js?vue&type=script&lang=js&"
import style0 from "./TokensApp.scss?vue&type=style&index=0&id=bfa0ccf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0ccf2",
  null
  
)

export default component.exports